import { Slider } from '@mui/material';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { _ } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class RangeSlider extends Component {
    static propTypes = {
        value: PropTypes.arrayOf(PropTypes.number).isRequired,
        step: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        unit: PropTypes.string.isRequired,
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        innerMin: PropTypes.number,
        innerMax: PropTypes.number,
    };

    static defaultProps = {
        format: (value) => value,
    };

    getMarks() {
        const { min, max } = this.props;
        return [
            {
                value: min,
                label: <div className={styles.markDown}>{this.props.format(min)}</div>,
            },
            {
                value: max,
                label: <div className={styles.markDown}>{this.props.format(max)}</div>,
            },
        ];
    }

    handleChange(value) {
        const { innerMin, innerMax, onChange } = this.props;
        if (innerMin && value[0] > innerMin) value[0] = innerMin;
        if (innerMax && value[1] < innerMax) value[1] = innerMax;
        return onChange(value);
    }

    renderValue(value, type) {
        const labels = { min: _('Mínimo'), max: _('Máximo') };
        return (
            <div className={styles.value}>
                {labels[type]}: <span className={styles.number}>{this.props.format(value)}</span>{' '}
                <span className={styles.unit}>{this.props.unit}</span>
            </div>
        );
    }

    render() {
        return (
            <div className={styles.root}>
                <div className={styles.values}>
                    {this.renderValue(this.props.value[0], 'min')}
                    {this.renderValue(this.props.value[1], 'max')}
                </div>
                <div className={styles.slider}>
                    <Slider
                        range
                        marks={this.getMarks()}
                        min={this.props.min}
                        max={this.props.max}
                        step={this.props.step}
                        value={this.props.value}
                        onChange={(_, value) => this.handleChange(value)}
                        mb={0}
                    />
                </div>
            </div>
        );
    }
}
